import { Box, Typography } from "@mui/material";
import React from "react";
import WorkStations from "./WorkStations";

const WorkStationsPage = () => {
  return (
    <Box>
      <Typography variant="h4" sx={{ textAlign: "center" }}>
        Work Stations
      </Typography>
      <WorkStations />
    </Box>
  );
};

export default WorkStationsPage;
